import {connect} from "react-redux";
import AddNextActivity from "./NextActivity";
import {bindActionCreators} from "redux";
import {dropdownData} from "../../../service/Account/action";
import {nextActivity, activityProposal, checkCloseOrDropped, newActivity, cancelActivity, distanceFromSite, maintenanceCost, getLeadGateType} from "../../../service/Activity/action";
import {documentUploadUrlPublic} from "../../../service/fileUpload/action";
import {fetchAssignee} from "../../../service/Assignment/action";
import {getOpportunity} from "../../../service/Opportunities/action";
import {accountDetailsById} from "../../../service/Account/action";
import {getPendingActivity, markAttendance} from "../../../service/DCC/action";
import {isCheckout} from "../../../service/CarService/action";
import {viewActivity} from "../../../service/Activity/action";

const mapStateToProps = (state) => ({
    nextActivityDetails:state.Activity.nextActivity,
    proposalActivity:state.Activity.proposalActivity,
    checkOpportunity:state.Activity.checkOpportunity,
    saveNewActivity:state.Activity.saveNewActivity,
    maintenanceCostDetails:state.Activity.maintenanceCostDetails,
    distance:state.Activity.distance,
    cancelActivityDetails:state.Activity.cancelActivity,
    leadGateTypes:state.Activity.leadGateTypes,
    dropdownValue:state.Dropdown.dropdownValue,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    getAssignee:state.AssignmentReducer.getAssignee,
    opportunityDetails:state.Opportunitie.opportunityDetails,
    accountDetails:state.Dropdown.accountDetailsById,
    pendingActivity:state.DCC.pendingActivity,
    attendance:state.DCC.attendance,
    isCheckoutDetails:state.CarService.isCheckout,
    activityByIdDetails:state.Activity.activityByIdDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            dropdownData,
            nextActivity,
            documentUploadUrlPublic,
            activityProposal,
            checkCloseOrDropped,
            newActivity,
            cancelActivity,
            distanceFromSite,
            maintenanceCost,
            fetchAssignee,
            getOpportunity,
            getLeadGateType,
            accountDetailsById,
            getPendingActivity,
            markAttendance,
            isCheckout,
            viewActivity
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AddNextActivity);
